angular.module('bmsApp.merrymaids.job')
	.controller('MMJobViewCtrl', [
		'$state',
		'$scope',
		'$timeout',
		'$window',
		'$compile',
		'$ngBootbox',
		'notify',
		'NgTableParams',
		'NoteSvc',
		'ConfigService',
		'MMJobSvc',
		'MMJobPartSvc',
		'EmailSvc',
		'$q',
		'AuthService',
		'VisitPhotoSvc',
		'VisitRiskAssessmentResponseSvc',
		'LeavingPromptResponseSvc',
		'PhotoSvc',
		function ($state,
				  $scope,
				  $timeout,
				  $window,
				  $compile,
				  $ngBootbox,
				  notify,
				  NgTableParams,
				  NoteSvc,
				  ConfigService,
				  MMJobSvc,
				  MMJobPartSvc,
				  EmailSvc,
				  $q,
				  AuthService,
				  VisitPhotoSvc,
				  VisitRiskAssessmentResponseSvc,
				  LeavingPromptResponseSvc,
				  PhotoSvc) {

			function init() {
				if ($state.is('main.merrymaids.proformaQuote.read')) {
					self.isProformaQuote = true;
					self.pageTitle = 'Proforma Quote Overview';
				}
				else if ($state.is('main.merrymaids.quote.read')) {
					self.isQuote = true;
					$scope.MMJobMainCtrl.jobOrQuote = 'quote';
					self.pageTitle = 'Quote Overview';
				}
				else if ($state.is('main.merrymaids.job.read')) {
					self.isJob = true;
					$scope.MMJobMainCtrl.jobOrQuote = 'job';
					self.pageTitle = 'Job Overview';
				}

				self.loading = true;
				loadJob()
					.then(function () {
						initVisitCalendar();
						self.loading = false;
					});
			}

			function initVisitCalendar() {
				if (self.visitCalendarShown) {
					return;
				}

				// timeout on tab select so that calendar container has a width when show
				$timeout(function () {
					$scope.$apply(function () {
						angular.extend(self.visitCalendar, {
							config: {
								displayEventTime: false,
								editable: self.job.inactive === false,
								// eventStartEditable: true,
								eventDurationEditable: false,
								eventRender: function (event, element) {
									var template = event.title;
									if (angular.isObject(event.jobPart) && event.jobPart.active === false) {
										template += '<div>Clean inactive</div>';
									}
									else {
										template += '<div ng-if="event.jobPart.preinvoice"><b>Pre-invoiced</b></div>';
										template += '<div class="job-part-event-preinvoice">' +
											'<a class="btn btn-link" ng-click="preinvoiceJobPart(); $event.stopPropagation();" ng-if="event.jobPart.can_preinvoice">Pre-Invoice Job</a>' +
											'<a class="btn btn-link" ng-click="viewInvoice(); $event.stopPropagation();" ng-if="event.jobPart.first_invoice">View Invoice</a>' +
											'<br/><a class="btn btn-link" ng-click="viewVisitPhotos(); $event.stopPropagation();" title="View Photos" href="javascript:;"><span class="glyphicon glyphicon-picture"></span></a>' +
											'<a class="btn btn-link" ng-if="event.jobPart.risk_assessment_responses_count" ng-click="viewVisitRiskAssessment(); $event.stopPropagation();" href="javascript:;" title="View Risk Assessment"><span class="glyphicon glyphicon-list-alt"></span></a>' +
											'<a class="btn btn-link" ng-if="event.jobPart.leaving_prompt_responses_count" ng-click="viewLeavingPromptResponse(); $event.stopPropagation();" href="javascript:;" title="View Leaving Prompts"><span class="glyphicon glyphicon-list-alt"></span></a>' +
											'<a class="btn btn-link" ng-if="event.jobPart.journey_map_file" ng-click="$event.stopPropagation();viewJourneyMap(\''+(event.jobPart.journey_map_file ? event.jobPart.journey_map_file.url : '')+'\')" title="View journey map"><span class="fad fa-route"></span></a>' +
											'</div>';
									}
									element.find('.fc-title')
										.html(template);
									// create a new isolated scope for the event
									var eventScope = $scope.$new(true);
									$compile(element)(eventScope);
									angular.extend(eventScope, {
										event: event,
										preinvoiceJobPart: function () {
											$ngBootbox.confirm('Are you sure you wish to pre-invoice this clean?')
												.then(function () {
													MMJobPartSvc.preinvoice(event.jobPart.id)
														.then(function (response) {
															event.jobPart.can_preinvoice = false;
															event.jobPart.first_invoice = response.data.invoice;
															notify({
																message: 'Successfully pre-invoiced clean.'
															});
														}, function (errors) {
															notify({
																message: errors[0],
																classes: 'error'
															});
														});
												});
										},
										viewInvoice: function () {
											$scope.printInvoice(event.jobPart.first_invoice);
										},
										viewVisitPhotos: function () {
											if (self.job.inactive !== false) {
												return;
											}
											VisitPhotoSvc.showVisitPhotosModal('App\\Models\\Merrymaids\\JobPart', event.jobPart);
										},
										viewJourneyMap: function (url) {
											PhotoSvc.showViewModal('Journey Map', url);
										},
										viewVisitRiskAssessment: function () {
											// if (self.job.inactive !== false) {
											// 	return;
											// }
											VisitRiskAssessmentResponseSvc.showVisitRiskAssessmentModal('App\\Models\\Merrymaids\\JobPart', event.jobPart);
										},
										viewLeavingPromptResponse: function () {
											// if (self.job.inactive !== false) {
											// 	return;
											// }
											LeavingPromptResponseSvc.showLeavingPromptResponseModal('App\\Models\\Merrymaids\\JobPart', event.jobPart);
										},
									});
								},
								eventClick: function (event, jsEvent, view) {
									if (self.job.inactive !== false) {
										return;
									}
									MMJobPartSvc.showSaveCleanModal(self.job.id, event)
										.then(function (result) {
											if (result.success === true) {
												// Save successful, refetch events
												view.calendar.refetchEvents();
											}
										}, function () {
											// refetch on close in case of pre-invoicing
											view.calendar.refetchEvents();
										});
								},
								dayClick: function (date, jsEvent, view) {
									if (self.job.inactive !== false) {
										return;
									}
									MMJobPartSvc.showSaveCleanModal(self.job.id, date)
										.then(function (result) {
											if (result.success === true) {
												// Save successful, refetch events
												view.calendar.refetchEvents();
											}
										});
								},
								eventDrop: function (event, delta, revertFunc, jsEvent, ui, view) {
									if (self.job.inactive !== false) {
										return;
									}
									console.info(event);
									MMJobPartSvc.showMoveCleanModal(event)
										.then(function (result) {
											if (result.success === true) {
												// Save successful, refetch events
												view.calendar.refetchEvents();
											}
											else {
												// Save failed, revert event and show error
												revertFunc();
											}
										}, function () {
											// Move cancelled, revert event
											revertFunc();
										});
								}
							},
							eventSources: [
								{
									events: function (start, end, timezone, callback) {
										var config = {
											params: {
												job: {
													id: self.job.id
												},
												start: start.format(ConfigService.config.format.date.amDbDateTime),
												end: end.format(ConfigService.config.format.date.amDbDateTime)
											}
										};
										MMJobPartSvc.calendarEvents(config.params)
											.then(function (response) {
												callback(response.data.events);
											}, function () {
												console.log('Failed to load non-attendance events');
											});
									}
								}
							]
						});

						self.visitCalendarShown = true;
					});
				}, 100);
			}

			function initJobHistory() {
				if (self.jobHistoryTable.params) {
					return;
				}
				var tableParams = {
					page: 1, // show first page
					count: $scope.config.table.params.count, // count per page
					sorting: {
						job_date: 'desc'
					},
					filter: angular.copy(self.jobHistoryTable.filter)
				};
				var tableOptions = {
					total: 0, // length of data
					counts: $scope.config.table.settings.counts, // available page counts
					getData: function ($defer, params) {
						self.jobHistoryTable.updating = true;
						MMJobSvc.jobHistory(self.jobId, params.$params)
							.then(function (response) {
								params.total(response.data.job_history_count);
								$defer.resolve(response.data.job_history);
								self.jobHistoryTable.updating = false;
							});
					}
				};
				self.jobHistoryTable.params = new NgTableParams(tableParams, tableOptions);
			}

			function applyJobHistoryTableFilter() {
				angular.extend(self.jobHistoryTable.params.$params.filter, self.jobHistoryTable.filter);
			}

			function loadJob() {
				return $q.all({
					job: MMJobSvc.read(self.jobId),
					currentUser: AuthService.getUser(),
				})
					.then(function (responses) {
						self.job = responses.job.data.job;
						$scope.job = angular.copy(self.job);
						$scope.franchise = responses.currentUser.franchise;
					});
			}

			function deleteJob() {
				if (self.job.converted === false) {
					$ngBootbox.confirm('Are you sure you want to delete this quote?')
						.then(function () {
							MMJobSvc.delete(self.job.id)
								.then(function () {
									notify({
										message: 'Quote deleted successfully'
									});
									if ($state.is('main.merrymaids.quote.read')) {
										$state.go('main.merrymaids.quote.index');
									}
								}, function () {
									notify({
										message: 'Failed to delete quote',
										classes: 'error'
									});
								});
						});
				}
			}

			function cancelJob() {
				if (self.job.converted === true && self.job.inactive === false) {
					MMJobSvc.showCancelJobModal(self.job)
						.then(function (result) {
							if (result.success) {
								// job cancelled, reload page
								// $state.go won't seem to reload the page, so just re-calling init
								init();
							}
						});
				}
			}

			function reactivateJob() {
				if (self.job.converted === true && self.job.inactive === true) {
					MMJobSvc.showReactivateJobsModal(self.job.customer)
						.then(function (result) {
							if (result.success) {
								// job cancelled, reload page
								// $state.go won't seem to reload the page, so just re-calling init
								init();
							}
						});
				}
			}

			function onPrintCustomerConfirmationClick() {
				$ngBootbox.customDialog({
					title: 'Print Customer Confirmation',
					message: 'Would you like to include cleaning instructions?',
					buttons: {
						yes: {
							label: 'Yes',
							className: 'btn-success',
							callback: function () {
								openPrintCustomerConfirmation(self.job.id, true)
							},
						},
						no: {
							label: 'No',
							className: 'btn-danger',
							callback: function () {
								openPrintCustomerConfirmation(self.job.id, false)
							},
						},
					},
				})
			}

			function openPrintCustomerConfirmation(jobId, includeCleaningInstructions) {
				if (includeCleaningInstructions) {
					includeCleaningInstructions = 1
				}
				else {
					includeCleaningInstructions = 0
				}
				$window.open('/merrymaids/job/customer-confirmation?jobId=' + jobId + '&includeCleaningInstructions=' +
					includeCleaningInstructions, '_blank')
			}

			$scope.addNote = function () {
				var note = {
					object_type: 'App\\Models\\Merrymaids\\Job',
					object_id: $scope.job.id
				};
				NoteSvc.showSaveModal(note);
			};

			function emailForm(emailAddress, objectType, objectId) {
				console.log(objectType);
				var email = {
					to: emailAddress,
					object_type: objectType,
					object_id: objectId
				};

				EmailSvc.showSendModal(email, self.job.customer);
			}

			function showCustomerNotes() {
				self.notes.activeObjectType = 'App\\Models\\Crm\\Customer';
				self.notes.activeObjectId = self.job.customer.id;
			}

			function showJobNotes() {
				self.notes.activeObjectType = 'App\\Models\\Merrymaids\\Job';
				self.notes.activeObjectId = self.job.id;
			}

			function showJobComplaints() {
				self.complaints.activeObjectType = 'App\\Models\\Merrymaids\\Job';
				self.complaints.activeObjectId = self.job.id;
			}

			var self = $scope.MMJobViewCtrl = {
				pageTitle: '',
				isProformaQuote: false,
				isQuote: false,
				isJob: false,
				loading: true,
				jobId: parseInt($state.params.jobId),
				job: null,
				methods: {
					init: init,
					initVisitCalendar: initVisitCalendar,
					initJobHistory: initJobHistory,
					onPrintCustomerConfirmationClick: onPrintCustomerConfirmationClick,
					deleteJob: deleteJob,
					cancelJob: cancelJob,
					reactivateJob: reactivateJob,
					emailForm: emailForm,
					showCustomerNotes: showCustomerNotes,
					showJobNotes: showJobNotes,
					showJobComplaints: showJobComplaints,
				},
				visitCalendar: {},
				jobHistoryTable: {
					filter: {
						dateRangeArray: {
							startDate: moment()
								.subtract(1, 'month')
								.format('YYYY-MM-DD'),
							endDate: moment()
								.format('YYYY-MM-DD')
						}
					},
					rangePickerConfig: angular.merge(angular.copy($scope.config.datePicker.range), {
						options: {
							opens: 'left'
						}
					}),
					applyFilter: applyJobHistoryTableFilter
				},
				notes: {
					view: 'job',
					api: {}
				},
				complaints: {
					api: {},
				},
			};

		}
	]);
